const state = {
  userInfo: {}, // 用户信息
  asyncRoutes: [],
  breadcrumbs: []
  // loginType: 0, // 登录类型 0普通用户 1 机构用户
};

const getters = {
  userInfo: (state) => state.userInfo,
  getRoutes: (state) => state.routes,
  getUserName: (state) => state.userInfo?.userName,
  getRoutes: (state) => state.asyncRoutes,
  getBreadCrumbs: (state) => {
    const breadcrumbs = JSON.parse(
      window.top.localStorage.getItem("routerMatched") || "[]"
    );
    return breadcrumbs;
  },
  getMenuName: (state) => {
    const breadcrumbs = JSON.parse(
      window.top.localStorage.getItem("routerMatched") || "[]"
    );
    if (breadcrumbs && breadcrumbs[1]) {
      return breadcrumbs[1].txt || "";
    }
    return "";
  },
  getAvatar: (state) =>
    state.userInfo?.userPhoto || require("@/assets/images/user_empty.png")
};

const actions = {
  setAsyncRoutes({ commit }, routes) {
    commit("SET_ASYNC_ROUTES", routes);
  },
  saveUserInfo({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      try {
        localStorage.setItem("opc-token", userInfo.token);
        localStorage.setItem("opc-userInfo", JSON.stringify(userInfo));
        commit("SAVE_USER_INFO", userInfo);
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  },
  logout({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      try {
        commit("LOGOUT");
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }
};

const mutations = {
  SET_ASYNC_ROUTES(state, routes) {
    state.asyncRoutes = routes;
  },
  SAVE_USER_INFO(state, userInfo) {
    state.userInfo = {
      ...state.userInfo,
      ...userInfo
    };
  },
  LOGOUT(state) {
    state.routes = [];
    state.userInfo = {};
    window.top.localStorage.removeItem("opc-userInfo");
    window.top.localStorage.removeItem("opc-token");
    window.top.localStorage.removeItem("vuex");
    return Promise.resolve();
  },
  SET_STATE(state, { value, key }) {
    if (typeof key === "string") {
      state[key] = value;
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
